import { render } from "./Footer.vue?vue&type=template&id=21ae2ecf&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=21ae2ecf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-21ae2ecf"

export default script